import React from 'react'

export default function TopHome(props) {
    let element = props.element && props.element.data;
    if(element) {
        let slides = element['slides'];
        return (
                <div className="top top--home">
                    <div className="slider top__slider">
                        <div className="content-slider">
                        {
                            slides && slides.map(slide => (
                                <div className="slide" key={slide.sort}>
                                    <div className="top__shader top__shader--bc-1"></div>
                                    <div className="top__triangle"></div>
                                    <div className="top__background">
                                        { 
                                            slide['media']['main_image'] && slide['media']['main_image']['path'] && 
                                                <div className="image cover">
                                                    <img src={slide['media']['main_image']['path']} alt= {slide['media']['main_image']['path']} title={slide['media']['main_image']['path']} />
                                                </div>
                                        }
                                        {
                                            slide['media']['loop_video'] && slide['media']['loop_video']['path'] &&
                                                <div className="top__cover-video">
                                                    <video className="top__video" preload="auto" src={slide['media']['loop_video']['path']} loop autoplay muted>
                                                        <source className="mp4" src={slide['media']['loop_video']['path']} type="video/mp4" />
                                                    </video>
                                                </div>
                                        }
                                    </div>
                                    <div className="top__foreground foreground--relative">
                                        <div className="top__content">
                                        {
                                            slide['media']['icon'] && slide['media']['icon']['path'] &&
                                                <div className="top__icon flex">
                                                    <a href="http://www.gijoncongresos.com/page/15341-programa-embajadores" target="_blank" rel="noopener noreferrer"><img src={slide['media']['icon']['path']} alt={element['seo']['general']['title']} title={element['seo']['general']['title']} /></a>
                                                </div>
                                        }
                                        {
                                            slide['content'] && 
                                                <div dangerouslySetInnerHTML={{__html: slide['content']}} />
                                        }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }                    
                        </div>
                    {
                        slides && slides.length > 1 &&
                            <div className="top__buttons">
                            {
                                slides.map((slide,key) => <span className="slider__button" key={`slides-button-${key}`}></span>)
                            }
                            </div>
                    }
                    </div>
                </div>

        )
    } else {
        return null
    } 
}
